import { useEffect, useMemo, useState } from "react";
import { IconProps } from "../../../types/icon";
import { OrderType } from "../../../types/pagination";


type ThProps = {
  width?: string;
  sorted?: boolean;
  sort?: {
    active: boolean,
    target: string,
    onSort: (target: string, value: OrderType) => void;
  };
  children: React.ReactNode;
}

function CaretDownIcon({className = ""}: IconProps) {
  return (
    <svg className={className} width="800px" height="800px" viewBox="0 0 24 24" fill="none">
      <path d="M6.1018 8C5.02785 8 4.45387 9.2649 5.16108 10.0731L10.6829 16.3838C11.3801 17.1806 12.6197 17.1806 13.3169 16.3838L18.8388 10.0731C19.5459 9.2649 18.972 8 17.898 8H6.1018Z" fill="currentColor"/>
    </svg>
  )
}

export default function Th({width = 'auto',sorted=false, sort, children}: ThProps) {
  const [currentOrder, setCurrentOrder] = useState<OrderType>('none');
  const isActive = useMemo(() => sort?.active && currentOrder !== 'none', [currentOrder, sort?.active]);

  useEffect(() => {
    if (sorted && sort && !sort.active) {
      setCurrentOrder('none');
    }
  }, [sort, sorted])

  function handleSort() {
    if (sorted && sort) {
      const nextOrder = getNextOrder();
      sort.onSort(sort.target, nextOrder);
      setCurrentOrder(nextOrder);
    }
  }

  function getNextOrder(): OrderType {
    switch (currentOrder) {
      case 'none':
        return 'ASC';
      case 'ASC':
        return 'DESC';
      case 'DESC':
        return 'none';
    }
  }

  return (
    <th style={{width}} className={`px-1.5 py-2.5 text-end text-gray text-[14px] leading-[1.3125rem] font-normal whitespace-nowrap
    ${isActive ? "text-secondary" : ""}`}>
      {children}
      {
        sorted && <button className="ml-1.5" onClick={handleSort}>
          <CaretDownIcon className={`size-3 transition-transform ${currentOrder === "ASC" ? "-rotate-180" : ""}`} />
        </button>}
    </th>
  )
}